module.exports = __webpack_public_path__ + "static/media/sdg_icon_14.de0510a0.png";